import React from 'react';
import { classnames } from '../../../utils/classnames';
import { CorporateLoginService } from '../login-service';
import useMobileResize from '../../../hooks/useMobileResize';
import { redirectToLocal } from '../../../utils/location';
import { clearLocalCorporateStorage, IsCorporateAuthorized, STORAGE_DATA } from '../../../utils/auth';

export default function CorporateLoginWidget() {
  const corporateToken = IsCorporateAuthorized();
  const fullName = localStorage.getItem(STORAGE_DATA.CORPORATE_FULL_NAME);
  const isMobile = useMobileResize();
  const userIconSettings = {
    width: isMobile ? 21 : 16,
    height: isMobile ? 22 : 17,
  };
  const handleClickLogout = () => {
    CorporateLoginService.logout().then(() => {
      clearLocalCorporateStorage();
      redirectToLocal('/flu-vaccination-vouchers');
    });
  };

  if (corporateToken) {
    return (
      <div className={classnames('login-widget__profile', 'blue-theme', isMobile && 'login-widget__profile_mobile')}>
        <a href="/corporate-profile" className="login-widget__link tpg_buttons">
          <UserIcon width={userIconSettings.width} height={userIconSettings.height} />
          <span className="login-widget__name tpg_buttons">{fullName}</span>
        </a>
        {isMobile ? (
          <LogoutIcon onClick={handleClickLogout} />
        ) : (
          <>
            <div className="login-widget__separator"></div>
            <button className="login-widget__logout tpg_buttons" onClick={handleClickLogout}>
              Logout
            </button>
          </>
        )}
      </div>
    );
  }

  return (
    <div
      className={classnames(
        'login-widget__module',
        'login-corporate-button',
        isMobile ? 'login-widget__module_mobile' : '',
      )}
    >
      <UserIcon width={userIconSettings.width} height={userIconSettings.height} />
      <a href="/corporate-login" className="tpg_buttons">
        Corporate Login
      </a>
    </div>
  );
}

function LogoutIcon({ onClick }) {
  return (
    <svg
      className="icon logout-icon"
      onClick={onClick}
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 14.5V17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3.063M8 10h10m0 0-2.5-2.5M18 10l-2.5 2.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function UserIcon({ width, height }) {
  return (
    <svg width={width} height={height} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 12.6654V11.9987C2.5 10.5259 3.69391 9.33203 5.16667 9.33203H7.83333C9.30609 9.33203 10.5 10.5259 10.5 11.9987V12.6654M10.5 7.33203C11.6046 7.33203 12.5 6.4366 12.5 5.33203C12.5 4.22746 11.6046 3.33203 10.5 3.33203M14.5 12.6654V11.9987C14.5 10.5259 13.3061 9.33203 11.8333 9.33203H11.5M8.5 5.33203C8.5 6.4366 7.60457 7.33203 6.5 7.33203C5.39543 7.33203 4.5 6.4366 4.5 5.33203C4.5 4.22746 5.39543 3.33203 6.5 3.33203C7.60457 3.33203 8.5 4.22746 8.5 5.33203Z"
        stroke="#1B75BB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
